import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesIdsConnectMain } from './modules/ui/Main';

const IdsConnectPage = (
  <SuspensePage>
    <PagesIdsConnectMain />
  </SuspensePage>
);

export default IdsConnectPage;
